import React from 'react';
import './UserTable.css';

const UserTable = ({ users, currentUser, onEdit, onDelete, onResetPassword }) => {
  const isManager = currentUser?.role === 'manager';

  const getRoleBadge = (role) => {
    const badges = {
      manager: { text: '主管', icon: '👔', class: 'manager' },
      purchasing: { text: '採購', icon: '📦', class: 'purchaser' },
      sales: { text: '業務', icon: '💼', class: 'sales' }
    };
    return badges[role] || badges.sales;
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="table-container">
      <table className="user-table">
        <thead>
          <tr>
            <th>用戶資訊</th>
            <th>帳號</th>
            <th>角色</th>
            <th>狀態</th>
            <th>建立日期</th>
            <th>最後登入</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const badge = getRoleBadge(user.role);
            return (
              <tr key={user._id}>
                <td>
                  <div className="user-cell">
                    <div className="user-avatar-sm">{user.name[0]}</div>
                    <div>
                      <div className="user-name-cell">{user.name}</div>
                      <div className="user-email">{user.username}</div>
                    </div>
                  </div>
                </td>
                <td>{user.username}</td>
                <td>
                  <span className={`role-badge role-badge-${badge.class}`}>
                    {badge.icon} {badge.text}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${user.isActive ? 'status-active' : 'status-inactive'}`}>
                    {user.isActive ? '啟用' : '停用'}
                  </span>
                </td>
                <td>{formatDate(user.createdAt)}</td>
                <td>{formatDate(user.lastLogin)}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn-icon"
                      onClick={() => onResetPassword(user)}
                      title="修改密碼"
                    >
                      🔑
                    </button>
                    <button
                      className="btn-icon"
                      onClick={() => onEdit(user)}
                      title="編輯"
                    >
                      ✏️
                    </button>
                    {isManager && user._id !== currentUser._id && (
                      <button
                        className="btn-icon btn-icon-danger"
                        onClick={() => onDelete(user)}
                        title="刪除"
                      >
                        🗑️
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {users.length === 0 && (
        <div className="empty-state">
          <p>沒有符合條件的用戶</p>
        </div>
      )}
    </div>
  );
};

export default UserTable;
